module.exports = __webpack_public_path__ + "sv.2a44c3241d00a7e69879.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/sv.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/sv.svg
// module chunks = styles